<template>
  <div class="MediaGridItemText"
    :style="mainElementStyles">

    <h1 class="MediaGridItemText-title t-heading-sm"
      v-if="data.title">
      {{ data.title }}
    </h1>

    <p class="MediaGridItemText-subtitle t-text-sm"
      v-if="data.subtitle">
      {{ data.subtitle }}
    </p>

    <markdown class="MediaGridItemText-text t-text-sm"
      v-if="data.text"
      :content="data.text" />

  </div>
</template>

<script>
export default {
  name: 'MediaGridItemText',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    /**
     * Styles for the main element
     * @return {Object}
     */
    mainElementStyles () {
      return this.data.style
    }
  }
}
</script>

<style>
@import 'properties';

.MediaGridItemText {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.MediaGridItemText-title {
  /* Leading compensation */
  margin-top: -5px; /* 0px */
  margin-bottom: -6px; /* 0px */
}

.MediaGridItemText-subtitle {
  /* Leading compensation */
  margin-top: 14px; /* 18px */

  /* background: red; */
}

.MediaGridItemText-text {
  /* Leading compensation */
  margin-top: 10px; /* 18px */
  margin-bottom: -5px; /* 0px */
}
</style>



// WEBPACK FOOTER //
// MediaGridItemText.vue?e877aaae